module.exports = {
      id: "icon-headset-usage",
      viewBox: "0 0 14.219 15.009",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-headset",
      toString: function () {
        return this.url;
      }
    }